import * as Types from './types.generated';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type TotalCompetitorsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type TotalCompetitorsQuery = { __typename?: 'Query', totalCompetitors: number };


export const TotalCompetitorsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"totalCompetitors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCompetitors"}}]}}]} as unknown as DocumentNode<TotalCompetitorsQuery, TotalCompetitorsQueryVariables>;